document.addEventListener('DOMContentLoaded', function () {
  initMobileMenu();
  initFaq();
  initQuantitySelector();
  initProductGallery();
  initScrollAnimations();
  initUgcVideos();
});

function initMobileMenu() {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  const close = document.querySelector('[data-mobile-menu-close]');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => menu.classList.add('is-open'));
  close?.addEventListener('click', () => menu.classList.remove('is-open'));
  menu.addEventListener('click', (e) => {
    if (e.target === menu) menu.classList.remove('is-open');
  });
}

function initFaq() {
  const items = document.querySelectorAll('[data-faq-item]');
  items.forEach(item => {
    const question = item.querySelector('[data-faq-question]');
    question.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');
      items.forEach(i => i.classList.remove('is-open'));
      if (!isOpen) item.classList.add('is-open');
    });
  });
}

function initQuantitySelector() {
  const wrappers = document.querySelectorAll('[data-quantity-wrapper]');
  wrappers.forEach(wrapper => {
    const input = wrapper.querySelector('input[type="number"]');
    const decrease = wrapper.querySelector('[data-quantity-decrease]');
    const increase = wrapper.querySelector('[data-quantity-increase]');

    decrease?.addEventListener('click', () => {
      const value = parseInt(input.value, 10) || 1;
      const min = parseInt(input.min, 10) || 1;
      if (value > min) input.value = value - 1;
    });

    increase?.addEventListener('click', () => {
      const value = parseInt(input.value, 10) || 1;
      const max = parseInt(input.max, 10) || 99;
      if (value < max) input.value = value + 1;
    });
  });
}

function initProductGallery() {
  const mainImage = document.querySelector('[data-product-main-image]');
  const thumbs = document.querySelectorAll('[data-product-thumb]');

  if (!mainImage || thumbs.length === 0) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.getAttribute('data-full-image');
      if (src) mainImage.src = src;
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
}

function initScrollAnimations() {
  const animatedElements = document.querySelectorAll('.section, .feature-card, .faq-item, .zigzag-item, .review-card, .ugc-video');

  if (!('IntersectionObserver' in window)) {
    animatedElements.forEach(el => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  animatedElements.forEach(el => observer.observe(el));
}

function initUgcVideos() {
  const videos = document.querySelectorAll('.ugc-video video');
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.3 });

  videos.forEach(video => observer.observe(video));
}
